@if (loading()) {
  <app-loading
    [isCircle]="false"
    [hasLoaded]="!loading()"
    [hasFailed]="!!error()?.length"
    (retryClicked)="getAvailableFields()" />
} @else {
  <app-filtered-search
    [fields]="filterFields()"
    [hideSearch]="true"
    [constrainFilterMenu]="true"
    [defaultFilters]="defaults()"
    (filtersChange)="filtersChange.emit($event)"
    type="chip"
    display="inline"></app-filtered-search>
  @if (!filterFields()?.length) {
    <p>No fields available for filtering</p>
  }
}
